export const PromoCode = {
  ADD_DISCOUNT: 'Add Discount',
  ENTER_PROMO_CODE_DESC:
    'Please type your promo code to apply it to your checkout order.',
  APPLY: 'Apply',
};
